// src/pages/PlatformAdminNotificaciones.js
import React, { useEffect, useMemo, useState } from 'react';
import { FaBell } from 'react-icons/fa';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import ManagerSystemNotifications from '../components/manager/ManagerSystemNotifications';
import PlatformBackButton from '../components/PlatformBackButton';
import './PlatformAdminNotificaciones.css';

const PlatformAdminNotificaciones = () => {
    const [fraccionamientos, setFraccionamientos] = useState([]);
    const [selectedFraccionamientoId, setSelectedFraccionamientoId] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;

        const fetchFraccionamientos = async () => {
            try {
                const snapshot = await getDocs(collection(db, 'fraccionamientos'));
                if (cancelled) {
                    return;
                }

                const items = snapshot.docs.map((docSnap) => {
                    const data = docSnap.data() || {};
                    return {
                        id: docSnap.id,
                        nombre: data.nombre || data.name || 'Fraccionamiento sin nombre',
                    };
                }).sort((a, b) => a.nombre.localeCompare(b.nombre));

                setFraccionamientos(items);
                if (items.length > 0) {
                    setSelectedFraccionamientoId((prev) => prev || items[0].id);
                }
            } catch (error) {
                console.error('PlatformAdminNotificaciones: error al cargar fraccionamientos', error);
                setFraccionamientos([]);
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };

        fetchFraccionamientos();

        return () => {
            cancelled = true;
        };
    }, []);

    const selectedFraccionamiento = useMemo(
        () => fraccionamientos.find((item) => item.id === selectedFraccionamientoId) || null,
        [fraccionamientos, selectedFraccionamientoId],
    );

    return (
        <div className="platform-notifications-page">
            <header className="platform-notifications-header" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
                <div className="platform-notifications-header-content" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <div className="platform-notifications-header-icon">
                        <FaBell />
                    </div>
                    <div>
                        <h1>Notificaciones del Sistema</h1>
                        <p>Consulta la actividad reciente de administradores y residentes por fraccionamiento.</p>
                    </div>
                </div>

                <div className="header-actions-right-group" style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', flexWrap: 'wrap' }}>
                    <div className="platform-notifications-toolbar-inline" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <label htmlFor="platformNotificationsFraccionamiento" style={{ fontSize: '0.85rem', fontWeight: '700', color: '#475569', display: 'flex', alignItems: 'center', gap: '8px', margin: 0 }}>
                            <span>Fraccionamiento:</span>
                            <select
                                id="platformNotificationsFraccionamiento"
                                value={selectedFraccionamientoId}
                                onChange={(event) => setSelectedFraccionamientoId(event.target.value)}
                                disabled={loading || fraccionamientos.length === 0}
                                style={{ padding: '8px 12px', borderRadius: '10px', border: '1px solid #cbd5e1', fontSize: '0.9rem', color: '#0f172a', background: '#ffffff', minWidth: '220px', cursor: 'pointer', outline: 'none' }}
                            >
                                {fraccionamientos.map((item) => (
                                    <option key={item.id} value={item.id}>{item.nombre}</option>
                                ))}
                                {fraccionamientos.length === 0 && <option value="">No hay fraccionamientos registrados</option>}
                            </select>
                        </label>
                    </div>
                    <PlatformBackButton step={-1} className="platform-notifications-back" style={{ alignSelf: 'center', margin: 0 }} />
                </div>
            </header>

            {loading ? (
                <div className="platform-notifications-empty">Cargando fraccionamientos...</div>
            ) : selectedFraccionamiento ? (
                <ManagerSystemNotifications fraccionamientoId={selectedFraccionamiento.id} hideHeader={true} />
            ) : (
                <div className="platform-notifications-empty">No se encontraron fraccionamientos para mostrar notificaciones.</div>
            )}
        </div>
    );
};

export default PlatformAdminNotificaciones;
